const SubAbasDocumentos = (id: string) => [
  {
    label: 'Dados Gerais',
    rota: `/daf/maisopcoes/documentos/ficha/${id}/dadosgerais`,
  },
  //   {
  //     label: 'Produtos',
  //     rota: `/daf/produtosdaf/denominacoes/ficha/${id}/produtos`,
  //   },
];

export default SubAbasDocumentos;
